import { useEffect, useState } from 'react';

interface WindowSize {
    width?: number;
    height?: number;
}

export const useWindowSize = (): WindowSize => {
    const [windowSize, setWindowSize] = useState<WindowSize>(getBounds);

    useEffect(() => {
        const setMeasuredHeight = () => {
            setWindowSize(getBounds());
        };

        window.addEventListener('resize', setMeasuredHeight);
        // visualViewport is supported in iOS 15 and later
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', setMeasuredHeight);
        }
        return () => {
            window.removeEventListener('resize', setMeasuredHeight);
            if (window.visualViewport) {
                window.visualViewport.removeEventListener(
                    'resize',
                    setMeasuredHeight,
                );
            }
        };
    }, []);

    return windowSize;
};

const getBounds = (): WindowSize => ({
    width: measureWidth(),
    height: measureHeight(),
});
const measureHeight = (): number | undefined => {
    if (!isClient()) return undefined;
    if (window.visualViewport) return window.visualViewport.height;
    return document.documentElement?.clientHeight || window.innerHeight;
};
const measureWidth = (): number | undefined => {
    if (!isClient()) return undefined;
    if (window.visualViewport) return window.visualViewport.width;
    return document.documentElement?.clientWidth || window.innerWidth;
};
const isClient = () =>
    typeof window !== 'undefined' && typeof document !== 'undefined';
